export { default } from "./InquirySuccess";
